<div class="oral-notifications-form">
  <form [formGroup]="formModel" class="p-fluid">
    <div class="field">
      @if (isServiceLineTabWidgetEnabled) {
        <label class="field-required">Urgent Notification Type: </label>
      }
      @if (!isServiceLineTabWidgetEnabled) {
        <label class="field-required">Oral Notification Type: </label>
      }
      <div class="p-field-value">
        <p-multiSelect formControlName="oralNotificationType" display="chip" [options]="oralNotificationTypes" placeholder="Select Type"
          appendTo="body" styleClass="form-control" (onChange)="loadSubTypesOnSelection($event)">
        </p-multiSelect>
      </div>
    </div>
    <div class="field">
      <label class="field-required">Notification Sub-Type: </label>
      <div class="p-field-value">
        <p-select formControlName="notificationSubType" [options]="oralNotificationSubTypes"
          placeholder="Select Sub-Type" appendTo="body" styleClass="form-control">
        </p-select>
      </div>
    </div>
     <div class="field">
      @if (isServiceLineTabWidgetEnabled) {
        <label>HCPCS Description: </label>
      }
      @if (!isServiceLineTabWidgetEnabled) {
        <label>HCPC Description: </label>
      }
      <div class="p-field-value">
        {{ formModel?.get('hcpcsDescription')?.value }}
      </div>
    </div>
    <div class="field">
      <label class="field-required">Notification Note: </label>
      <div class="p-field-value">
        <textarea pInputTextarea formControlName="notificationNote" rows="5" maxlength="500" class="p-resize-vertical"></textarea>
      </div>
    </div>
    <div class="field">
      <label class="field-required">Notification Date/Time: </label>
      <div class="p-field-value oral-notification-calendar">
        <p-date-picker
          formControlName="notificationDatetime"
          [showTime]="true"
          hourFormat="12"
          appendTo="body"
          placeholder="Choose a date"
          [readonlyInput]="true"
          [showSeconds]="true"
          styleClass="form-control"
          [showIcon]="true"
        ></p-date-picker>
      </div>
    </div>
    <div class="field">
      <label class="field-required">Outcome: </label>
      <div class="p-field-value">
        <div class="outcome-container">
          <button
            type="button"
            class="outcome-button"
            [class.active]="formModel.get('outcome').value === 'Complete - made contact'"
            (click)="setOutcome('Complete - made contact')">
            Complete - made contact
          </button>
          <button
            type="button"
            class="outcome-button"
            [class.active]="formModel.get('outcome').value === 'Complete - no contact'"
            (click)="setOutcome('Complete - no contact')">
            Complete - no contact
          </button>
        </div>
      </div>
    </div>
  </form>
  @if (mode === ViewMode.View || mode === ViewMode.Edit) {
    <div class="small-font-size">
      <div class="flex mb-2">
        <label class="custom-label">Author: </label>
        <div class="font-semibold">
          {{model?.createdBy | userProfileCredentialsByEmail | async}}
        </div>
      </div>
      <div class="flex mb-2">
        <label class="custom-label">Created on: </label>
        <div class="font-semibold">
          {{model?.createdOn | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}
        </div>
      </div>
      @if (model?.modifiedOn) {
        <div class="flex">
          <label class="custom-label">Modified on: </label>
          <div class="font-semibold">
            {{model?.modifiedOn | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}
          </div>
        </div>
      }
    </div>
  }
  @if (mode !== ViewMode.View) {
    <div class="flex justify-end mt-6">
      <button
        class="p-button-secondary mr-2"
        pButton
        label="Cancel"
        (click)="onCancel()"
      ></button>
      <button
        pButton
        label="Save"
        [disabled]="formModel.invalid || !isFormModified"
        (click)="onSubmit()"
      ></button>
    </div>
  }
</div>

<p-confirmDialog
  #confirmDiscard
  key="confirmDiscard"
  header="Confirmation"
  appendTo="body"
  [style]="{width: '398px'}"
  rejectButtonStyleClass="p-button-info"
  rejectLabel="Back"
  acceptLabel="Discard Changes"
  >
</p-confirmDialog>
